import type { CurrencyCode } from "Models/CurrencyCodes";
import { getCurrencySymbol } from "Utils/CurrencyUtils";

// Accepts any ISO 4217 code string — Intl handles the formatting, so callers
// holding the generated API enum don't need to cast to Models/CurrencyCodes.
export const useCurrencySymbol = (currency?: CurrencyCode | string) => {
  if (!currency) {
    return null;
  }

  return getCurrencySymbol(currency);
};
